// used in the user application list
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['moveUp', 'moveDown']

  // if we find more elements that have .move-up, .move-down we will add it's parent container here
  buttonParentClasses = 'div.grid-cell, div.field-group-entry, .drawer-item';

  /*
    NOTES: For the future:
    use target to handle the dom elements once we refactor the other js code
    data-controller="move-up-down" is on the .list-drawer-items and #n-group-**

    might get a little tricky here since there are other children that we need to skip
    like the .ngroup-heading and .ngroup-template. maybe for the new refactor, we'll
    change the layout and set it up so its easier to access
    
    <div class="n-group-heading show_privacy_switch">
    <div class="field-group-entry">
    <div class="ngroup-template">
  */

  connect() {
    this.update_disabled(); // this will connect with every node change on the DOM
  }

  // Enable/disable move buttons based on item position (first/middle/last)
  update_disabled() {
    let controller = this.element;
    let $parent = $(controller).parent().children(this.buttonParentClasses).not('.ngroup-template, .hidden');

    if (!$parent || $parent.length === 0) {
      return;
    }

    if ($parent.length <= 1) {
      $parent.find('.move-up, .move-down').addClass('disabled').attr('disabled', 'disabled').removeAttr('data-action');
      return;
    }

    $parent.each((index, item) => {
      const $item = $(item);
      const isFirst = index === 0;
      const isLast = index === $parent.length - 1;

      const $upBtn = $item.find('.move-up');
      const $downBtn = $item.find('.move-down');

      if (isFirst) {
        $upBtn.addClass('disabled').attr('disabled', 'disabled').removeAttr('data-action');
        $downBtn.removeClass('disabled').removeAttr('disabled').attr('data-action', 'click->move-up-down#moveDown');
      } else if (isLast) {
        $upBtn.removeClass('disabled').removeAttr('disabled').attr('data-action', 'click->move-up-down#moveUp');
        $downBtn.addClass('disabled').attr('disabled', 'disabled').removeAttr('data-action');
      } else {
        $upBtn.removeClass('disabled').removeAttr('disabled').attr('data-action', 'click->move-up-down#moveUp');
        $downBtn.removeClass('disabled').removeAttr('disabled').attr('data-action', 'click->move-up-down#moveDown');
      }
    });
  }

  handleDisabledClassAndAttr(button) {
    button.addClass('disabled');
    button.removeAttr('data-action');
  }

  // Animate two elements swapping positions over 500ms
  animateCss(animate1, animate2, distance) {
    animate1.css('position', 'relative').animate({ top: -distance }, 500);
    animate2.css('position', 'relative').animate({ top: distance }, 500);
  }

  // Remove animation CSS and physically swap DOM positions
  swapPositionsCss(clickedDiv, targetDiv, insertBefore1, insertBefore2) {
    clickedDiv.removeClass('animated').css({ position: '', top: '' });
    targetDiv.removeClass('animated').css({ position: '', top: '' });

    insertBefore1.insertBefore(insertBefore2);
    insertBefore2.insertBefore(insertBefore1);
  }

  setFocusOnFirstLabel(clickedDiv) {
    const $firstLabel = clickedDiv.find('label').first();
    const inputId = $firstLabel.attr('for');
    
    if (inputId) {
      $('#' + inputId).focus();
    }
  }

  makeAjaxCall(url) {
    $.ajax({
      url: url,
      method: "POST",
      success: () => {
        console.log("Element moved successfully");
      },
      error: (xhr, status, error) => {
        console.error("Failed to move element:", error);
      }
    });
  }

  moveUp(e) {
    e.preventDefault();
    let this_controller = this;
    let clickedDiv = $(e.currentTarget).closest(this.buttonParentClasses);
    let prevDiv = clickedDiv.prevAll(this.buttonParentClasses).not('.ngroup-template, .hidden').first();

    if (!prevDiv.length) return;

    const url = clickedDiv.find('a.move-up').attr('href');

    $.when(
      this_controller.animateCss(clickedDiv, prevDiv, (clickedDiv.offset().top - prevDiv.offset().top))
    ).done(function () {
      this_controller.swapPositionsCss(clickedDiv, prevDiv, prevDiv, clickedDiv);
      this_controller.update_disabled();
      this_controller.setFocusOnFirstLabel(clickedDiv);

      if (url) {
        this_controller.makeAjaxCall(url);
      }
    });
  }

  moveDown(e) {
    e.preventDefault();
    let this_controller = this;
    let clickedDiv = $(e.currentTarget).closest(this.buttonParentClasses);
    let nextDiv = clickedDiv.nextAll(this.buttonParentClasses).not('.ngroup-template, .hidden').first();

    if (!nextDiv.length) return;

    const url = clickedDiv.find('a.move-down').attr('href');

    $.when(
      this_controller.animateCss(nextDiv, clickedDiv, (nextDiv.offset().top - clickedDiv.offset().top))
    ).done(function () {
      this_controller.swapPositionsCss(clickedDiv, nextDiv, clickedDiv, nextDiv);
      this_controller.update_disabled();
      this_controller.setFocusOnFirstLabel(clickedDiv);

      if (url) {
        this_controller.makeAjaxCall(url);
      }
    });
  }
}
